import axios from 'axios';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;
  return 'https://backend.kanaiyacosmetics.com';
};

const API_BASE_URL = getApiBaseUrl();
const TOKEN_KEY = 'pos_token';

export const api = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);

const setStoredToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    return;
  }

  localStorage.removeItem(TOKEN_KEY);
};

export const clearStoredToken = () => setStoredToken(null);

api.interceptors.request.use((config) => {
  const token = getStoredToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers?.Authorization) {
    delete config.headers.Authorization;
  }

  return config;
});

export const getErrorMessage = (requestError, fallbackMessage) => {
  const apiMessage = requestError?.response?.data?.message;
  const validationErrors = requestError?.response?.data?.errors;

  if (validationErrors && typeof validationErrors === 'object') {
    const firstFieldErrors = Object.values(validationErrors)[0];
    if (Array.isArray(firstFieldErrors) && firstFieldErrors.length > 0) {
      return firstFieldErrors[0];
    }
  }

  return apiMessage || fallbackMessage;
};

export const getCurrentUser = async () => {
  const response = await api.get('/api/user');
  return response.data;
};

export const loginUser = async ({ email, password }) => {
  const response = await api.post('/api/login', { email, password });
  const { token, user } = response.data;
  setStoredToken(token);
  return user;
};

export const registerUser = async ({ name, email, password, confirmPassword }) => {
  const response = await api.post('/api/register', {
    name,
    email,
    password,
    password_confirmation: confirmPassword
  });
  const { token, user } = response.data;
  setStoredToken(token);
  return user;
};

export const logoutUser = async () => {
  try {
    await api.post('/api/logout');
  } finally {
    clearStoredToken();
  }
};

export const getItems = async (params = {}) => {
  const response = await api.get('/api/items', { params });
  return response.data;
};

export const createItem = async ({ name, price, barcode }) => {
  const response = await api.post('/api/items', { name, price, barcode });
  return response.data;
};

export const updateItem = async (itemId, { name, price, barcode }) => {
  const response = await api.put(`/api/items/${itemId}`, { name, price, barcode });
  return response.data;
};

export const deleteItem = async (itemId) => {
  const response = await api.delete(`/api/items/${itemId}`);
  return response.data;
};

export const getTypes = async () => {
  const response = await api.get('/api/payments');
  return response.data;
};

export const createType = async ({ name }) => {
  const response = await api.post('/api/payments', { name });
  return response.data;
};

export const updateType = async (typeId, { name }) => {
  const response = await api.put(`/api/payments/${typeId}`, { name });
  return response.data;
};

export const deleteType = async (typeId) => {
  const response = await api.delete(`/api/payments/${typeId}`);
  return response.data;
};

export const createSale = async (payload) => {
  const response = await api.post('/api/sales', payload);
  return response.data;
};

export const getSales = async (params = {}) => {
  const response = await api.get('/api/sales', { params });
  return response.data;
};

export const getSaleDetail = async (saleId) => {
  const response = await api.get(`/api/sales/${saleId}`);
  return response.data;
};

export const getSalesAnalytics = async () => {
  const response = await api.get('/api/sales/analytics');
  return response.data;
};
